// extracted by mini-css-extract-plugin
module.exports = {"container":"IconTabButton_container__merxG","activeTab":"IconTabButton_activeTab__6oBn_"};